import KanbanBoardStepsAPI from '../../../api/kanban/boardSteps';

export const state = {
  uiFlags: {
    isUpdating: false,
  },
};

export const getters = {
  getUIFlags: _state => _state.uiFlags,
};

export const actions = {
  create: async ({ dispatch, commit }, { boardId, ...payload }) => {
    commit('SET_UI_FLAG', { isUpdating: true });
    try {
      await KanbanBoardStepsAPI.create(boardId, payload);
      await dispatch('kanban/boards/fetchOne', boardId, { root: true });
    } finally {
      commit('SET_UI_FLAG', { isUpdating: false });
    }
  },

  update: async ({ dispatch, commit }, { boardId, id, ...payload }) => {
    commit('SET_UI_FLAG', { isUpdating: true });
    try {
      await KanbanBoardStepsAPI.update(boardId, id, payload);
      await dispatch('kanban/boards/fetchOne', boardId, { root: true });
    } finally {
      commit('SET_UI_FLAG', { isUpdating: false });
    }
  },

  delete: async ({ dispatch, commit }, { boardId, id }) => {
    commit('SET_UI_FLAG', { isUpdating: true });
    try {
      await KanbanBoardStepsAPI.destroy(boardId, id);
      await dispatch('kanban/boards/fetchOne', boardId, { root: true });
    } finally {
      commit('SET_UI_FLAG', { isUpdating: false });
    }
  },
};

export const mutations = {
  SET_UI_FLAG(_state, data) {
    _state.uiFlags = { ..._state.uiFlags, ...data };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
